import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { RegisterModel } from 'src/app/models/repository/register.model';

import { RegisterService } from 'src/app/services/register.service';
import { confirmPasswordValidator } from '../shared/validators/password-validator';

import { Router } from '@angular/router';
import { LoginModel, Regions } from '../models/legacy';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';
import { ToastService } from '../shared-new/services/toast.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PrivacyPolicyPopupComponent } from '../popups/privacy-policy-popup/privacy-policy-popup.component';
import { TermsAndConditionsPopupComponent } from '../popups/terms-and-conditions-popup/terms-and-conditions-popup.component';
import { HttpErrorHandlerService } from '../services/http-error-handler.service';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import Constants from 'src/app/constants.json';

@Component({
  selector: 'registration-page',
  templateUrl: './registration-page.component.html',
  styleUrls: ['./registration-page.component.scss'],
})
export class RegistrationPageComponent implements OnInit, AfterViewInit {
  public registerForm: FormGroup;
  public regions: Regions[];
  public isLoader = false;
  public isUniquieEmail = false;
  public responseSuccess: string;
  public responseError: string;
  public submitted = false;
  public dialCode = '+61';
  public countries: any[];
  public user: LoginModel;
  public isLoginStatus: boolean;
  isRegistered = false;
  public closeResult: string;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  selectedCountryISO: CountryISO;
  preferredCountries: CountryISO[] = Constants.preferredCountries.map((item) => item as CountryISO);
  @ViewChild('titleInput') titleInput: ElementRef;

  public constructor(
    private readonly registration: RegisterService,
    private readonly commonService: CommonService,
    private readonly router: Router,
    private readonly authService: AuthService,
    private toastService: ToastService,
    private httpErrorHandler: HttpErrorHandlerService,
    private readonly modalService: NgbModal
  ) {
  }

  public validateUserName(formData: RegisterModel): void {
    if (formData && formData.emailAddress) {
      this.registration
        .isUserNameTaken(formData.emailAddress)
        .subscribe((response: any) => {
          this.isUniquieEmail = false;

          if (response && response['body']) {
            this.isLoader = false;
            this.isUniquieEmail = true;
            this.responseError =
              'Email: ' + formData.emailAddress + ' already exists';
            this.toastService.error(this.responseError);
          } else {
            this.registerUser(formData);
          }
        });
    }
  }

  SetCountryISO(event: any) {
    var region = this.registerForm.get('region').value;
    const countryCode = this.regions.find(x => x.region == region);
    this.selectedCountryISO = countryCode.countryISO as any;
  }

  public submitForm(formData: any): void {
    this.submitted = true;
    formData["mobile"] = formData.phone.internationalNumber.replace(formData.phone.dialCode, '');
    formData["countryCode"] = formData.phone.dialCode;
    if (this.registerForm.invalid) {
      return;
    }


    this.isLoader = true;
    this.responseError = null;
    this.validateUserName(formData);
  }

  public registerUser(user: RegisterModel): void {
    user.isVet = true;
    this.registration.register(user).subscribe(
      (data) => {
        if (data) {
          this.isRegistered = true;
          // this.localStorageService.setItem('User', JSON.stringify(data));
          this.isLoader = false;

          // // this.userAuthenticate();
          // this.toastService.success(
          //   'Your account has been created, please check your email to activate your account.'
          // );

          // setTimeout(() => {
          //   window.location.href = '/login';
          // }, 5000);
        }
      },
      (errorResponse: Error) => {
        this.isLoader = false;
        const errorData = JSON.parse(JSON.stringify(errorResponse));
        if (errorData?.error && errorData?.status === 401) {
          this.responseError = errorData?.error?.message;
        }
        if (errorData?.error && errorData?.status === 400) {
          this.httpErrorHandler.ShowErrorMessage(errorData);
          // this.responseError = errorData?.error[0]?.message;
          // this.toastService.warning(this.responseError);
        }
      }
    );
  }

  public userAuthenticate(): void {
    this.isLoginStatus = this.authService.isAuthenticated();
    this.authService.getUserData().subscribe((data) => {
      if (data) {
        this.user = JSON.parse(data);
      }
    });
  }

  public openTermsConditionsPopup() {
    const modalRef = this.modalService.open(TermsAndConditionsPopupComponent, {
      ariaLabelledBy:  'Terms-Conditions-Popup-Id',
      centered: true,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.result.then(
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  public openPrivacyPolicyPopup() {
    const modalRef = this.modalService.open(PrivacyPolicyPopupComponent, {
      ariaLabelledBy:  'Privay-Policy-Popup-Id',
      centered: true,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.result.then(
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public ngOnInit(): void {
    this.userAuthenticate();

    if (this.isLoginStatus == true) {
      this.router.navigate(['/sales']);
    }

    this.commonService.getRegions().subscribe((regions) => {
      this.regions = regions;
    });

    this.commonService.getCountries().subscribe((response) => {
      if (response.body) {
        const responseData = JSON.parse(JSON.stringify(response.body));
        if (responseData) {
          this.countries = responseData;

          //if (this.countries && this.countries?.length > 0) {
           
          //}
        }
      }
    });

    this.registerForm = RegisterModel.asFormGroup(null);
  }

  public ngAfterViewInit(): void {
    if (this.titleInput) {
      setTimeout(() => {
        this.titleInput.nativeElement.focus();
      });
    }
  }
}
